import { ChatMessage } from "../types/chat";
import { GoBackStackItem } from "../types/hooks";

export function getLastBotMessage(
  messages: ChatMessage[]
): ChatMessage | undefined {
  return messages
    .filter(
      (msg) =>
        msg.messageType === "bot" &&
        msg.nodeUuid !== "00000000-0000-0000-0000-000000000000"
    )
    .pop();
}

export function hasVideoInLastMessage(messages: ChatMessage[]): boolean {
  const lastBotMessage = getLastBotMessage(messages);
  if (!lastBotMessage) return false;

  // Check if media ends with .mp4
  if (lastBotMessage.media && lastBotMessage.media.endsWith(".mp4")) {
    return true;
  }

  return false;
}

export function buildActionsFromLastBotMessage(
  canGoBack: boolean,
  goBackStack: GoBackStackItem[],
  messages: ChatMessage[]
): string[] {
  const actions: string[] = [];

  if (canGoBack) {
    actions.push("go back");
  }

  const hasValidNodeInStack = goBackStack.some(
    (item) =>
      item.nodeUuid !== "PlaceHolderUUID" &&
      item.nodeUuid !== "00000000-0000-0000-0000-000000000000"
  );

  if (hasValidNodeInStack) {
    actions.push("repeat");
  }

  // Add "play video" action if the last message has a video
  if (hasVideoInLastMessage(messages)) {
    actions.push("play video");
  }

  return actions;
}

export function extractOptionsFromMessage(
  message: ChatMessage
): Array<[string, string]> {
  return message.options || [];
}

export function extractLinksFromMessage(
  message: ChatMessage
): Array<[string, string]> {
  const links: Array<[string, string]> = [];
  const linkMatches = message.text.match(
    /<span\s+class="custom-link"\s+data-id="([^"]*)"\s+data-info="([^"]*)"[^>]*>(.*?)<\/span>/g
  );
  if (linkMatches) {
    linkMatches.forEach((link) => {
      const match = link.match(
        /<span\s+class="custom-link"\s+data-id="([^"]*)"\s+data-info="([^"]*)"[^>]*>(.*?)<\/span>/
      );
      if (match) {
        const [, dataId, , spanText] = match;
        links.push([spanText, dataId]);
      }
    });
  }
  return links;
}

export function extractOptionsAndLinksFromLastBotMessage(
  messages: ChatMessage[]
): Array<[string, string]> {
  const lastBotMessage = getLastBotMessage(messages);
  if (!lastBotMessage) return [];

  const options = extractOptionsFromMessage(lastBotMessage);
  const links = extractLinksFromMessage(lastBotMessage);

  // Combine options and links for compare request
  return [...options, ...links];
}
